export type State =
  | "UNSTARTED"
  | "STARTED"
  | "SHOW_HEADER_TOOLTIP"
  | "COMPLETED";
export const unstarted: "UNSTARTED" = "UNSTARTED";
export const started: "STARTED" = "STARTED";
export const showHeaderTooltip: "SHOW_HEADER_TOOLTIP" = "SHOW_HEADER_TOOLTIP";
export const completed: "COMPLETED" = "COMPLETED";
